import './TermsAndConditions.scss';
import { PDFRender } from '../../../utils/PDFViewer/PDFRender';
import { PdfPreviewType } from '../../../constants/previewType';
import axiosCall from '../../../utils/axiosCall';
import { useEffect, useState } from 'react';
import Loader from '../../../components/CommonComponents/Loader/Loader';
//import {termAndCondition} from './FHL_TOC.pdf';

export const TermsAndConditions = () => {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const isMobile = window.innerWidth < 1000;

  useEffect(() => {
    getDoc();
  }, []);

  const getDoc = async () => {
    try {
      setLoading(true);
      const url = '/policy/getPolicy/1';
      const response = await axiosCall.get(url);
      if (response?.status === 200) {
        setUrl(response?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      {loading && <Loader isSmallLoader />}
      {url?.length > 0 &&
        (isMobile ? (
          <div style={{ textAlign: 'center', padding: '3rem 1rem' }}>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="mobile-policy-pdf"
            >
              📄 Open Terms and Conditions in Browser
            </a>
          </div>
        ) : (
          <PDFRender
            previewType={PdfPreviewType.Url}
            url={url}
            fromHomePage={true}
          />
        ))}
    </div>
  );
};
